import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import styles from "./DraggableItem.module.css";
import IconButton from "./IconButton.js";
import { IconGripVertical } from "@tabler/icons-react";

export default function DraggableItem({ id, children }) {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
  };
  return (
    <div ref={setNodeRef} style={style} className={styles.wrapper}>
      <IconButton
        icon={IconGripVertical}
        className={styles.handle}
        {...attributes}
        {...listeners}
      />
      {children}
    </div>
  );
}
